// removed by extract-text-webpack-plugin
module.exports = {"root":"_2IhTi_tNB9W_hebOwTOogU","logoContainer":"_3KE_iEuGCJqelNj1FzlSmd","logo":"vpXV6nTT6HtSrpP0kqdHP","paperContainer":"_3c53nBRzyTAh0uqXGvRgRC","title":"_30VW9zMt6KR9UpBX5BOTcm","content":"_2RjOUtK-lsIEiesJ6HPX7i","button":"_3KN4qya2V-rZ2t-_m7sfmr","logout":"_3x809XDTmlLuQQkm04wCO8"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Layout/NoVerified/styles.css
// module id = 2554
// module chunks = 0